module.exports = __webpack_public_path__ + "img/messenger-logo.37d4db9c.svg";